import { CSSProperties } from 'react';
import {
  ACCENT_BUTTON,
  COLORS,
  DISPLAY_STRETCH,
  FONTS,
  GLASS,
  META,
} from '../../../../globalStyles';

export const styles: Record<string, CSSProperties> = {
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    gap: '1.25rem',
    marginTop: '3rem',
  },
  panel: {
    ...GLASS,
    border: `1px solid ${COLORS.border}`,
    padding: '2rem 1.75rem',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '0.9rem',
  },
  platform: {
    ...META,
    fontSize: '0.72rem',
    color: COLORS.label,
  },
  status: {
    fontFamily: FONTS.display,
    fontStretch: DISPLAY_STRETCH,
    fontWeight: 600,
    fontSize: '1.75rem',
    lineHeight: 1.1,
    color: COLORS.text,
  },
  detail: {
    fontSize: '1rem',
    lineHeight: 1.7,
    color: COLORS.muted,
  },
  storeLink: {
    ...ACCENT_BUTTON,
    fontFamily: FONTS.body,
    fontWeight: 600,
    fontSize: '1rem',
    padding: '0.95rem 1.75rem',
    textDecoration: 'none',
  },
};
